import React, { Component } from 'react';
import Test from '../../test';
import ApiService from '../../../services/apiService';
import './pageTest.css';
import NotFound from '../404';
import ErrorBoundry from '../../error-boundry';
import Snowfall from 'react-snowfall'

class PageTest extends Component {
  apiService = new ApiService();

  state = {
    url: '',
    status: true,
    loading: true,
    backgroundImage: null,
    isSnow: false
  };

  updatePageTest() {
    const url = this.props.match.params.name;

    this.apiService
      .getQuiz(url)
      .then(({ url, backgroundImage, isSnow, testType }) => {
        this.setState({
          url,
          loading: false,
          backgroundImage,
          isSnow
        });
      })
      .catch(({ status }) => {
        this.setState({
          status: false,
          loading: false
        });
      });
  }

  componentDidMount() {
    this.updatePageTest();
  }

  render() {
    const { url, status, backgroundImage, isSnow } = this.state;
    const location = (window.location != window.parent.location)
        ? document.referrer
        : document.location.href;
    const getLocation = (href) => {
      const l = document.createElement("a");
      l.href = href;
      return l;
    };
    const hostName = getLocation(location).hostname;
    return (
      <ErrorBoundry>
        {status ? (
          <div
            className={`page-test`}
            style={
              this.state.backgroundImage
                ? {
                    backgroundImage: `url(https://ppc.world/quizzes/api${backgroundImage})`
                  }
                : null
            }
          >
            <Test url={url} getData={this.apiService.getQuiz} />
            {isSnow ? <Snowfall  snowflakeCount={300}/> : null}
          </div>
        ) : (
          <NotFound />
        )}
      </ErrorBoundry>
    );
  }
}

export default PageTest;
